<template>
    <div>
     <Banner/>
     <Overview/>
     <!-- <About/>
     <ProgramHighlights/>
     <WhyChooseWTI/>
     <DetailsPage/>
     <AlumniTestimonials/>
     <ThesisTeam/>
     <FAQ/>
     <FutureOfConservation/> -->



    </div>
</template>
<script>
import Banner from "./banner";
import Overview from "./overview";
// import About from "./about";
// import ProgramHighlights from "./programHighlights";
// import WhyChooseWTI from "./whyChooseWTI";
// import DetailsPage from "./detailsPage";
// import AlumniTestimonials from "./alumniTestimonials";
// import ThesisTeam from "./thesisTeam";
// import FAQ from "./faq";
// import FutureOfConservation from "./futureOfConservation";



export default {
    components:{
        Banner,
        Overview,
        // About,
        // ProgramHighlights,
        // WhyChooseWTI,
        // DetailsPage,
        // AlumniTestimonials,
        // FAQ,
        // ThesisTeam,
        // FutureOfConservation
    }
    
}   
</script>